import { render, staticRenderFns } from "./QuotationApply.vue?vue&type=template&id=514126ca&scoped=true"
import script from "./QuotationApply.vue?vue&type=script&lang=js"
export * from "./QuotationApply.vue?vue&type=script&lang=js"
import style0 from "./QuotationApply.vue?vue&type=style&index=0&id=514126ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514126ca",
  null
  
)

export default component.exports